// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__rmYJv","ttl":"styles_ttl__9Ep0e","faqList":"styles_faqList__RhVZN","contact":"styles_contact__RyBH0"};